<template>
  <div>
    <Head />
    <div class="wrapper" v-if="SearchData">
      <section class="main">
        <div class="container">
          <div class="title">
            <h1>搜尋結果: {{ SearchData.Keyword }}</h1>
          </div>
          <ul class="list">
            <li v-for="Post in Posts" :key="Post.PId">
              <a href="javascript:void(0)" @click="gotoPost(Post)">
                <img v-if="Post.Image" :src="SearchData.SiteUrl + Post.Image" alt="">
                <img v-if="!Post.Image" src="img/img_1.jpg" alt="">
                <p>{{ Post.Title }}</p>
              </a>
            </li>
          </ul>
          <paginate :no-li-surround="false" :page-count="pageAll" :page-range="3" :margin-pages="1"
            :click-handler="loadList" :prev-text="'«'" :next-text="'»'" :prev-link-class="'page-link'"
            :next-link-class="'page-link'" :container-class="'pagination'" :page-class="'page-item'"
            :page-link-class="'page-link'" :active-class="'active'" :hide-prev-next="false" v-if="pageAll > 1">
          </paginate>
        </div>
      </section>
    </div><!-- wrapper -->
    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

const messages = {
  zh_tw: {
  },
  en: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Search",
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      SearchData: null,
      Posts: null,
      local: "zh_tw",
      pageAll: 0,
      perPage: 6,
    };
  },
  beforeRouteUpdate(to, from, next) {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/Html/Search",
        {
          params: { Keyword: to.params.Keyword },
        }
      )
      .then((response) => {
        this.SearchData = response.data;
        this.loadList(1);
      })
      .catch((error) => {
        console.log(error);
      });
    next();
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/Html/Search",
        {
          params: { Keyword: this.$route.params.Keyword },
        }
      )
      .then((response) => {
        this.SearchData = response.data;
        this.loadList(1);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("is_site_lang")) {
      i18n.locale = $cookies.get("is_site_lang");
      this.local = $cookies.get("is_site_lang");
    } else {
      i18n.locale = $cookies.get("is_site_lang");
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url:
          this.$store.state.src +
          this.$store.state.subDirectory +
          "/Html/SearchList",
        type: "post",
        data: {
          Keyword: this.$route.params.Keyword,
          page: page,
          perPage: that.perPage
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.status == 1) {
            that.Posts = res.Posts;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            document.body.scrollTop = 0;
          }
        },
      });
    },
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (Post.Blank) {
          window.open(Post.Url, "_blank");
        } else {
          location.href = Post.Url;
        }
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId },
        });
      }
    },
  },
};
</script>

